(() => {
  const params = new URLSearchParams(window.location.search);

  const selectedSize = (params.get('fwr_size') || '').trim();
  const sizeOptionHandle = (params.get('fwr_size_option') || '').trim().toLowerCase();

  if (!selectedSize) return;

  // roda melhor em páginas que têm grid de produtos
  const gridContainer =
    document.querySelector('#ProductGridContainer') ||
    document.querySelector('.product-grid-container') ||
    document;

  const productLinks = Array.from(
    gridContainer.querySelectorAll('a.full-unstyled-link[href*="/products/"], a[href*="/products/"]')
  );

  if (!productLinks.length) return;

  const CACHE_PREFIX = 'fwr_prodjs_';
  const CACHE_TTL_MS = 10 * 60 * 1000; // 10 min
  const CONCURRENCY = 6;

  function getHandleFromUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const idx = parts.indexOf('products');
      return idx >= 0 && parts[idx + 1] ? parts[idx + 1] : null;
    } catch {
      return null;
    }
  }

  function cacheGet(handle) {
    try {
      const raw = sessionStorage.getItem(CACHE_PREFIX + handle);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.data) return null;
      if (Date.now() - obj.t > CACHE_TTL_MS) return null;
      return obj.data;
    } catch {
      return null;
    }
  }

  function cacheSet(handle, data) {
    try {
      sessionStorage.setItem(
        CACHE_PREFIX + handle,
        JSON.stringify({ t: Date.now(), data })
      );
    } catch {}
  }

  async function fetchProductJs(handle) {
    const cached = cacheGet(handle);
    if (cached) return cached;

    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('fetch failed');
    const data = await res.json();
    cacheSet(handle, data);
    return data;
  }

  function normalize(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function findSizeOptionIndex(productJs) {
    // productJs.options ex.: ["Tamanho","Cor"]
    const names = (productJs.options || []).map(o => normalize(o));

    // 1) se veio do link (fwr_size_option), tenta bater com o nome
    if (sizeOptionHandle) {
      const idx = names.indexOf(normalize(sizeOptionHandle));
      if (idx >= 0) return idx;
    }

    // 2) fallback padrão
    let idx2 = names.indexOf('size');
    if (idx2 === -1) idx2 = names.indexOf('tamanho');

    return idx2;
  }

  function hasAvailableVariantForSize(productJs, sizeValue) {
    if (!productJs || !Array.isArray(productJs.variants)) return false;

    const idx = findSizeOptionIndex(productJs);
    if (idx === -1) return false;

    const target = normalize(sizeValue);

    return productJs.variants.some(v => {
      if (!v || !v.available) return false;
      const optVal = (v.options && v.options[idx]) ? v.options[idx] : '';
      return normalize(optVal) === target;
    });
  }

  function hideCard(anchorEl) {
    const card =
      anchorEl.closest('.grid__item, li.grid__item, .card-wrapper, .product-grid__item') ||
      anchorEl.closest('li') ||
      anchorEl;

    card.style.display = 'none';
    card.setAttribute('data-fwr-hidden-by-size', '1');
  }

  const jobs = productLinks
    .map(a => ({ a, handle: getHandleFromUrl(a.getAttribute('href') || '') }))
    .filter(x => x.handle);

  if (!jobs.length) return;

  document.documentElement.classList.add('fwr-size-filtering');

  let i = 0;
  async function worker() {
    while (i < jobs.length) {
      const cur = jobs[i++];
      try {
        const p = await fetchProductJs(cur.handle);
        if (!hasAvailableVariantForSize(p, selectedSize)) {
          hideCard(cur.a);
        }
      } catch {
        // se falhar, não esconde (melhor do que ocultar errado)
      }
    }
  }

  Promise.all(Array.from({ length: CONCURRENCY }, worker))
    .finally(() => {
      document.documentElement.classList.remove('fwr-size-filtering');
    });
})();
